import { CardHeader, CardBody, CardFooter, HStack, Center, Box } from '@chakra-ui/react'
import { useParams, useSearchParams } from 'react-router-dom';
import { TableLayout } from "../../template/table/TableLayout";
import { Pagination } from "../../molecules/pagenation/Pagination";
import { DarkShadowCard } from '../../molecules/card/DarkShadowCard';
import { TableRowLayout } from '../../template/table/TableRowLayout';
import { CiStar } from "react-icons/ci";
import { CircularLoading } from '../../molecules/loading/CircularLoading';
import { useFetchPaginatedRatingsByRestaurantId } from '../../../hooks/kuitan/useFetchPaginatedRatingsByRestaurantId';
import { formatDate } from '../../../utils/formatDate';
import { RestaurantName } from '../../atoms/RestaurantName';
import { CommentPopover } from '../../molecules/CommentPopover';


export const RatingsForSalesman = () => {
  const { restaurantId = "" } = useParams();
  const [searchParams] = useSearchParams({ p: "1" });
  const page = Number(searchParams.get('p') || "1");
  const pageSize = 10;
  const { paginatedRatings, isLoading } = useFetchPaginatedRatingsByRestaurantId(pageSize, page, restaurantId);
  if (isLoading || !paginatedRatings) return <CircularLoading />
  const headers = ['エージェント名', '総合評価', 'お料理', 'ドリンク', '接客', '店内衛生', 'コメント', '投稿日'];
  const rows = paginatedRatings.ratings.map((rating) => (
    <TableRowLayout
      key={rating.id}
      size='sm'
      childrenList={[
        rating.agent_name,
        rating.overall,
        rating.food,
        rating.drink,
        rating.customer_service,
        rating.hygiene,
        <CommentPopover comment={rating.comment} />,
        formatDate(rating.posted_at),
      ]}
    />
  ));
  return (
    <DarkShadowCard>
      <CardHeader>
        <HStack spacing={2}>
          <Center bgColor='blue.500' color='white' p={1} borderRadius='20%' boxSize='30px'>
            <CiStar  />
          </Center>
          <Box fontSize='lg' fontWeight='bold'>
            <RestaurantName restaurantId={restaurantId} />
          </Box>
        </HStack>
      </CardHeader>
      <CardBody py={2}>
        <TableLayout headers={headers} rows={rows || []} size='sm' />
      </CardBody>
      <CardFooter>
        <Pagination totalItems={paginatedRatings.count} pageSize={pageSize}/>
      </CardFooter>
    </DarkShadowCard>
  );
};